export const START_TRACKING_EMAIL = 'START_TRACKING_EMAIL';

export const TRACKING_EMAIL_SUCCESS = 'TRACKING_EMAIL_SUCCESS';

export const TRACKING_EMAIL_FAILED = 'TRACKING_EMAIL_FAILED';